import type { CSSProperties, ReactNode } from 'react';

const Label = ({
  children,
  styles,
}: {
  children?: ReactNode;
  styles?: CSSProperties;
}) => {
  const fieldHeadingStyle: CSSProperties = {
    fontSize: '16px',
    margin: '16px 0px 8px 0px',
  };

  return (
    <h4
      className="blox-label"
      style={{ ...fieldHeadingStyle, ...styles }}
    >
      {children}
    </h4>
  );
};

export default Label;
